/**
 * Module dependencies.
 */
var Strategy = require('./strategy');


/**
 * Expose `Strategy` directly from package.
 */
exports = module.exports = Strategy;

/**
 * Export constructors.
 */
exports.Strategy = Strategy;



//////////////////
// WEBPACK FOOTER
// ./~/passport-strategy/lib/index.js
// module id = 275
// module chunks = 0